import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectAsyncReducer } from 'io-redux/store';
import { reducers as deliveryReducers, actionCreators as deliveryActionCreators } from '../resource/deliveryissue';
import { translate } from '../../../common/translations';
injectAsyncReducer('DELIVERY_ISSUE_RATING', deliveryReducers("DELIVERY_ISSUE_RATING", ["UPDATE"]));

class DeliveryDetailsIssueForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			productFeedbackDescription: '',
			deliveryFeedbackDescription: '',
			isSubmitting: false,
			errorMessage: '',
			successMessage: '',
			editContactNumber: '',
			editEmail: props.email || '',
			issueType: '',
			issueArea: '',
			productFeedback: 'missingItems',
			deliveryFeedback: 'wrongAddress',
			hasProductFeedback: false,
			hasDeliveryFeedback: false
		}

	}

	submitForm(e) {
		e.preventDefault();
		if (!this.state.isSubmitting) {
			this.setState({ isSubmitting: true });
			const options = {
				clientId: this.props.deliveryConfig.clientId,
				postcode: this.props.delivery.postcode,
				url: window.location.href,
				problem: {
					productFeedbackDescription: this.state.hasProductFeedback ? this.state.productFeedbackDescription : '',
					deliveryFeedbackDescription: this.state.hasDeliveryFeedback ? this.state.deliveryFeedbackDescription : '',
					productFeedback: this.state.hasProductFeedback ? this.state.productFeedback : '',
					deliveryFeedback: this.state.hasDeliveryFeedback ? this.state.deliveryFeedback : '',
					phone: this.state.editContactNumber,
					email: this.state.editEmail,
					issueType: this.state.issueType,
					issueArea: this.state.issueArea,
				},
			};
			this.props.crudActions.update(
				encodeURIComponent(this.props.delivery.clientDeliveryIdentifier),
				options,
				null,
			);
			this.setState({ errorMessage: '', successMessage: '', isSubmitting: true })
		}
	}

	handleChange(e) {
		const newValue = {};
		newValue[e.target.id] = e.target.value;
		this.setState(newValue);
	}

	componentWillReceiveProps(newProps, newState) {
		if (newProps.itemAction.error !== null) {
			this.setState({ isSubmitting: false, errorMessage: translate(newProps, 'Unable to save rating'), successMessage: '' });
			return;
		}
		if (newProps.itemAction.hasUpdated === true) {
			this.setState({ isSubmitting: false, errorMessage: '', issueDescription: '', editContactNumber: '', editEmail: '', successMessage: translate(newProps, 'Thank you for letting us know. We will investigate and reply as soon as we can.') });
			return;
		}
	}

	render() {
		const props = this.props;
		const styles = props.deliveryConfig.clientStyles;
		return <div className="row division">
			<div className="col-10 col-centered">
				<h3>{translate(this.props.lang, 'Please let us know if you had an issue with this delivery')}</h3>
				{this.state.successMessage ? <p>{this.state.successMessage}</p> : null}
				<form onSubmit={this.handleSubmit}>
					<div className="form-group row">
						<div className="col-12">
							<label>{translate(this.props.lang, 'Product Feedback')} </label>
							<input value={this.state.hasProductFeedback} onClick={ev => {
								this.setState({
									hasProductFeedback: !this.state.hasProductFeedback
								})
							}} type="checkbox" />

							{this.state.hasProductFeedback && <select id="productFeedback" className="input-sel form-control"
								value={this.state.productFeedback}
								onChange={this.handleChange.bind(this)}
							>
								<option value="Missing Items">{translate(this.props.lang, 'Missing Items')}</option>
								<option value="Incorrect Items">{translate(this.props.lang, 'Incorrect Items')}</option>
								<option value="Taste/Presentation">{translate(this.props.lang, 'Taste/Presentation')}</option>
								<option value="Other">{translate(this.props.lang, 'Other')}</option>
							</select>}

							<br />

							{this.state.hasProductFeedback && <React.Fragment><textarea
								type="text"
								placeholder={translate(this.props.lang, 'Description of issue')}
								className="form-control"
								rows="5"
								id="productFeedbackDescription"
								value={this.state.productFeedbackDescription}
								onChange={this.handleChange.bind(this)} /><br /></React.Fragment>}

							<label>{translate(this.props.lang, 'Delivery Feedback')} </label>
							<input value={this.state.hasDeliveryFeedback} onClick={ev => {
								this.setState({
									hasDeliveryFeedback: !this.state.hasDeliveryFeedback
								})
							}} type="checkbox" />
							{this.state.hasDeliveryFeedback && <select className="input-sel form-control" id="deliveryFeedback"
								value={this.state.deliveryFeedback}
								onChange={this.handleChange.bind(this)}
							>
								<option value="Wrong Address">{translate(this.props.lang, 'Wrong Address')}</option>
								<option value="Instructions not followed">{translate(this.props.lang, 'Instructions not followed')}</option>
								<option value="Too Late">{translate(this.props.lang, 'Too Late')}</option>
								<option value="Too Early">{translate(this.props.lang, 'Too Early')}</option>
								<option value="Received another customers box">{translate(this.props.lang, 'Received another customers box')}</option>
								<option value="Other">{translate(this.props.lang, 'Other')}</option>
							</select>}

							<br />

							{this.state.hasDeliveryFeedback && <textarea
								type="text"
								placeholder={translate(this.props.lang, 'Description of issue')}
								className="form-control"
								rows="5"
								id="deliveryFeedbackDescription"
								value={this.state.deliveryFeedbackDescription}
								onChange={this.handleChange.bind(this)} />}
						</div>
					</div>
					<div className="form-group row">
						<div className="col-6">
							<input
								type="text"
								placeholder={translate(this.props.lang, 'Phone Number')}
								className="input-lg form-control"
								id="editContactNumber"
								value={this.state.editContactNumber}
								onChange={this.handleChange.bind(this)} />
						</div>
						<div className="col-6">
							<input
								type="text"
								placeholder={translate(this.props.lang, 'Email')}
								className="input-lg form-control"
								id="editEmail"
								value={this.state.editEmail}
								onChange={this.handleChange.bind(this)} />
						</div>
					</div>
					<div className="form-group">
						{this.state.errorMessage ? <p>{this.state.errorMessage}</p> : null}
						{this.state.isSubmitting ? <p>{translate(this.props.lang, 'Submitting issue')}</p> : null}
						<input style={styles.button} type="submit" onClick={this.submitForm.bind(this)} className="trackButton btn-lg btn-primary mr-3" value={translate(this.props.lang, 'SUBMIT')} />
					</div>
				</form>
			</div>
		</div>;
	}
}

DeliveryDetailsIssueForm.contextTypes = {

};

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		searchParams: state.searchParams,
		searchValue: state.searchValue,
		item: state.DELIVERY_ISSUE_RATING === undefined || state.DELIVERY_ISSUE_RATING.item === undefined ? null : state.DELIVERY_ISSUE_RATING.item,
		itemAction: state.DELIVERY_ISSUE_RATING === undefined ? null : state.DELIVERY_ISSUE_RATING,
	}
};

const mapDispatchToProps = (dispatch) => ({
	crudActions: bindActionCreators(deliveryActionCreators("DELIVERY_ISSUE_RATING"), dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDetailsIssueForm);
